import * as React from "react";
import { Option } from "informed";
import { ConfigFieldTextArea } from "../../forms/informedv2/ConfigFieldTextArea";
import { ConfigFieldTextBox } from "../../forms/informedv2/ConfigFieldTextBox";
import { ConfigFieldDropdown } from "../../forms/informedv2/ConfigFieldDropdown";
import { Dropdown } from "../../forms/informedv2/Dropdown";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { ConfigurableDataItemIds } from "../../misc/api/ApiConfigurableDataItems";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export interface SiteFormModel {
    Id: string;
    SiteId: string;
    Name: string;
    Address: string;
    Country: string;
    TimeZone: string;
    Contact: string;
    Email: string;
    Phone: string;
}

export const SiteFormBody = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const { timeZones } = useReferenceContextProvider();
    const [countries, setCountries] = React.useState([]);
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const getCountries = async () => {
            const studyCountries = await client.client.getStudyCountries('countryCode,name', `studyId eq ${study.id}`, 'name');
            setCountries(studyCountries.value);
        };

        getCountries();

        return () => {
            client.abortController.abort();
        }
    }, [study.id]);

    return (
        <>
            <div className="row">
                <ConfigFieldTextBox
                    id="SiteId"
                    field="SiteId"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteNumber}
                />
                <ConfigFieldTextBox
                    id="Name"
                    field="Name"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteName}
                />
                <ConfigFieldTextBox
                    id="Contact"
                    field="Contact"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    itemId={ConfigurableDataItemIds.SiteInvestigator}
                />
            </div>
            <div className="row">
                <ConfigFieldTextArea
                    id="Address"
                    field="Address"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    itemId={ConfigurableDataItemIds.SiteAddress}
                />
                <ConfigFieldDropdown
                    id="Country"
                    field="Country"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteCountry}
                >
                    {countries.map(c => (<Option key={`Option${c.countryCode}`} value={c.countryCode}>{c.name}</Option>))}
                </ConfigFieldDropdown>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="TimeZone">Time Zone</label>
                    <Dropdown
                        id="TimeZone"
                        field="TimeZone"
                        required={true}
                    >
                        {timeZones.map(c => (<Option key={`Option${c.id}`} value={c.id}>{c.name}</Option>))}
                    </Dropdown>
                </div>

            </div>
            <div className="row">
                <ConfigFieldTextBox
                    id="Email"
                    field="Email"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteEmail}
                />
                <ConfigFieldTextBox
                    id="Phone"
                    field="Phone"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SitePhone}
                />
            </div>
        </>
    );
}
